export const formatTranslation = (translatedObj: any) : string => {
    if(translatedObj.message)
      return translatedObj.message;
    return "";
  }